import { currencyFormat } from '../../../Functions';

export function CBSHeaDCompose(page, rowL, cbs, dataUrl, data, cy) {
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 140;

    var splitTitle = doc.splitTextToSize(cy ? cy : '', 70);

    doc.text(20, _y, splitTitle);

    _y += _space;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop + _space, 50, 18);

    _y += _space;
    doc.setFont("times", "bold");
    doc.text('CARGO BOOKING SLIP', 110, _y, null, null, 'center');

    _y += _space * 2;

    doc.text(20, _y, 'Booking Reference:');
    doc.text(70, _y, data.bookingRef ? data.bookingRef : '');
    doc.setFont("times", "normal");

    doc.setFont("times", "italic");
    doc.text(148, _y, 'For Revision:');
    doc.setFont("times", "normal");

    return _y;
}

export function CBSBodyOneCompose(page, rowL, cbs, data, transaction) {
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    // _y += _space;
    // doc.setFont("times", "bold");
    // doc.text(20, _y, 'Old Booking Ref:');
    // doc.text(70, _y, data.oldBookingRef ? data.oldBookingRef : '');
    // doc.setFont("times", "normal");

    _y += _space * 1.5;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Shipper:");
    doc.setFont("times", "normal");
    var splitShipper = doc.splitTextToSize(data.shipperName ? data.shipperName : '', 50);
    doc.text(70, _y, splitShipper);
    if (splitShipper.length > 1) {
        _y += (_space * (splitShipper.length / 1.5))
    }
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Preferred Name:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.shipperPreferedName ? data.shipperPreferedName : '');
    doc.line(70, _y + 1, 120, _y + 1);
    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Consignee:");
    doc.setFont("times", "normal");
    var splitConsignee = doc.splitTextToSize(data.consigneeName ? data.consigneeName : '', 50);
    doc.text(70, _y, splitConsignee);
    if (splitConsignee.length > 1) {
        _y += (_space * (splitConsignee.length / 1.5))
    }
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Preferred Name:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.consigneePreferedName ? data.consigneePreferedName : '');
    doc.line(70, _y + 1, 120, _y + 1);

    if (transaction === "PIER") {
        _y += _space * 2;
    }
    else {
        _y += _space * 1.25;
    }

    doc.setFont("times", "bold");
    doc.text(20, _y, "Payor:");
    doc.setFont("times", "normal");
    if (data.modeOfPayment === "Prepaid" || data.modeOfPayment === "Account Origin") {
        doc.text(70, _y, "Shipper");
    }
    else if (data.modeOfPayment === "Collect" || data.modeOfPayment === "Account Destination") {
        doc.text(70, _y, "Consignee");
    }
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Mode of Payment:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.modeOfPayment ? data.modeOfPayment : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    return _y;
}

export function CBSBodyTwoCompose(page, rowL, cbs, data, transaction, ctsData) {
    let selectedData = ctsData ? ctsData.find(d => d.bookingRef === data.bookingRef) : null;
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Origin:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.originBranchName ? data.originBranchName : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Destination:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.destinationBranchName ? data.destinationBranchName : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    if (transaction === "PIER") {
        _y += _space * 2;
    }
    else {
        _y += _space * 1.25;
    }

    doc.setFont("times", "bold");
    doc.text(20, _y, "Cargo Type:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.cargoTypeName ? data.cargoTypeName : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Mode of Delivery:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.modeOfDeliveryName ? data.modeOfDeliveryName : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Container Van:");
    doc.setFont("times", "normal");
    let container = data.containerVan ? data.containerVan : selectedData && selectedData.containerVan ? selectedData.containerVan : '';
    doc.text(70, _y, container);
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Seal #:");
    doc.setFont("times", "normal");
    let sealNum = data.sealNum ? data.sealNum : selectedData && selectedData.sealNum ? selectedData.sealNum : '';
    doc.text(70, _y, sealNum);
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    return _y;
}

export function CBSBodyThreeCompose(page, rowL, cbs, data) {
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Commodity/Good:");
    doc.setFont("times", "normal");
    var splitGoods = doc.splitTextToSize(data.goods === "goodOthers" && data.goodOthers ? data.goodOthers : data.goods ? data.goods : '', 50);
    doc.text(70, _y, splitGoods);
    if (splitGoods.length > 1) {
        _y += ((_space * 0.5) * splitGoods.length)
    }
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Declared Value:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.declaredValue ? currencyFormat(data.declaredValue) : '0');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Packaging:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.packagingOthers && data.packagingOthers !== "" ? data.packagingOthers : data.packaging ? data.packaging : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Cargo Volume (CBM):");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.cargoVolume ? data.cargoVolume.toString() : '0');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Cargo Weight (Tons):");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.cargoWeight ? data.cargoWeight.toString() : '0');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Quantity :");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.quantity ? data.quantity.toString() : '0');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Unit:");
    doc.setFont("times", "normal");
    doc.text(70, _y, data.unit ? data.unit : '');
    doc.line(70, _y + 1, 120, _y + 1);

    doc.line(135, _y + 1, 190, _y + 1);

    return _y;
}

export function CBSBodyFourCompose(page, rowL, cbs, data) {
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space * 1.5;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Shipper Contact Person:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.shipperContactPerson ? data.shipperContactPerson : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Contact No:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.shipperContactNum ? data.shipperContactNum : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Fax Numer:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.shipperFaxNum ? data.shipperFaxNum : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Pick-Up Address:");
    doc.setFont("times", "normal");
    var shipperPickUpAddress = doc.splitTextToSize(data.shipperPickUpAddress ? data.shipperPickUpAddress : '', 110);
    doc.text(80, _y, shipperPickUpAddress);
    if (shipperPickUpAddress.length > 1) {
        _y += ((_space * 0.5) * shipperPickUpAddress.length)
    }
    doc.line(80, _y + 1, 190, _y + 1);
    
    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Pick-Up Area:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.origAreaName ? data.origAreaName : '');
    doc.line(80, _y + 1, 190, _y + 1);
    
    _y += _space * 1.5;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Consignee Contact Person:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.consigneeContactPerson ? data.consigneeContactPerson : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Contact No:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.consigneeContactNum ? data.consigneeContactNum : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Fax Numer:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.consigneeFaxNum ? data.consigneeFaxNum : '');
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Delivery Address:");
    doc.setFont("times", "normal");
    var consigneePickUpAddress = doc.splitTextToSize(data.consigneePickUpAddress ? data.consigneePickUpAddress : '', 110);
    doc.text(80, _y, consigneePickUpAddress);
    if (consigneePickUpAddress.length > 1) {
        _y += ((_space * 0.5) * consigneePickUpAddress.length)
    }
    doc.line(80, _y + 1, 190, _y + 1);

    _y += _space * 1.25;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Delivery Area:");
    doc.setFont("times", "normal");
    doc.text(80, _y, data.destAreaName ? data.destAreaName : '');
    doc.line(80, _y + 1, 190, _y + 1);
    
    return _y;
}

export function CBSFinalCompose(page, rowL, cbs, data, bookingData, user) {
    var doc = cbs;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space;

    doc.setFont("times", "bold");
    doc.text(20, _y, "Remarks:");
    doc.setFont("times", "normal");
    _y += _space * 1.25;

    var Remarks = data && data.length > 0 && data[0].remarks ? data.remarks : bookingData && bookingData.remarks ? bookingData.remarks :  "";
    var Remarks = data && data.length > 0 && data[0].remarks ? data.remarks : "";
    var FinalRemarks = data && data.length && data[0].bookingRemarks ? data[0].bookingRemarks + ", " + Remarks : Remarks;
    var splitFrom = doc.splitTextToSize(FinalRemarks, page.maxWidthInPoint - 5);
    doc.text(20, _y, splitFrom);

    doc.line(20, _y + 1, 190, _y + 1);
    // _y += _space * 1.25;
    // doc.line(20, _y + 1, 190, _y + 1);

    _y += _space * 2;

    // doc.text(20, _y, bookingData.shipperName ? bookingData.shipperName : '');
    doc.line(20, _y + 1, 100, _y + 1);

    doc.text(105, _y, 'Cargo Booked By:');
    // doc.text(143, _y, user.name);
    doc.text(143, _y, bookingData.bookedBy ? bookingData.bookedBy : '');
    doc.line(143, _y + 1, 190, _y + 1);
    _y += _space * 1.2;

    // doc.text(38, _y, "Shipper's Signature");
    doc.text(38, _y, "Signature Over Printed Name");
}